import { Bus } from 'baconjs'

export const signedUp = new Bus()
